module.exports = __webpack_public_path__ + "img/badge-list-thumb-082.56baf6ca.png";